"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOrderServiceFeeToJSON = exports.MenuOrderServiceFeeFromJSONTyped = exports.MenuOrderServiceFeeFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MenuOrderServiceFeeFromJSON(json) {
    return MenuOrderServiceFeeFromJSONTyped(json, false);
}
exports.MenuOrderServiceFeeFromJSON = MenuOrderServiceFeeFromJSON;
function MenuOrderServiceFeeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': (0, _1.ServiceFeeTypeFromJSON)(json['type']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'amount': json['amount'],
    };
}
exports.MenuOrderServiceFeeFromJSONTyped = MenuOrderServiceFeeFromJSONTyped;
function MenuOrderServiceFeeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, _1.ServiceFeeTypeToJSON)(value.type),
        'name': value.name,
        'description': value.description,
        'amount': value.amount,
    };
}
exports.MenuOrderServiceFeeToJSON = MenuOrderServiceFeeToJSON;
